<template>
  <div>
    <div class="banner">
      <div v-if="productPictureList.length > 1" class="banner-top">
        {{productPictureList[currentIndex].path.pictureName}}
        <i class="el-icon-share"/>
        <i class="el-icon-star-off"/>
      </div>
      <div v-if="productPictureList.length > 1" class="item">
        <img class="banner-img" :src="productPictureList[currentIndex].url">
      </div>
      <div v-if="productPictureList.length > 1" class="page">
        <ul>
          <!--          <li @click="gotoPage(prevIndex)">&lt;</li>-->
          <li
              v-for="(item,index) in productPictureList"
              :key="index"
              :class="{'current':currentIndex === index}"
              @click="gotoPage(index)">
            <img class="banner-img1" :src="item.url">
            <span>
              {{item.path.pictureName}}
            </span>
            <img v-if="currentIndex === index" class="banner-img2" src="../../../../public/img/up-arrow.png">
          </li>
          <!--          <li @click="gotoPage(nextIndex)">&gt;</li>-->
        </ul>
      </div>
    </div>

    <div
        style="border: 1px solid #e6e6e6;padding-top: 10px;margin-bottom: 20px;padding-bottom: 0;border-bottom: none">
      <div
          v-for="item in tableData"
          :key="item.pkid"
          style="border-bottom: 1px solid #e6e6e6;margin-bottom: 10px">
        <div v-if="item.groupType===10">
          <div>
            <div style="display: flex;flex-direction: row;align-items: center;border-bottom: 4px solid #eeeeee;padding: 10px 0">
              <img class="img" src="../../../../public/img/titlebg.png">
              <span class="product-span">
                {{item.groupName}}
              </span>
            </div>
            <div
                v-for="entity in item.productIntroductionTemplateParams"
                :key="entity.pkid"
                style="width: 95%;display: flex;flex-direction: row;
                  justify-content: space-between;align-items: center;
                  margin: 0 auto;border-bottom: 1px solid #eeeeee;padding: 10px 0">
              <span class="product-span2">
                {{entity.paramName}}
              </span>
              <div style="width: 75%;">
                <div v-if="entity.paramValueType === 20">
                  <div
                      v-for="(value,index5) in entity.enumerateList"
                      :key="index5"
                      class="product-span3"
                      style="margin-bottom: 3px;">
                    {{value}}
                  </div>
                </div>

                <div v-else class="product-span3">{{entity.paramValue}}</div>
              </div>
            </div>
          </div>
        </div>


        <div v-else-if="item.groupType===20">
          <div style="position: relative">
            <div style="display: flex;flex-direction: row;align-items: center;border-bottom: 4px solid #eeeeee;padding: 10px 0">
              <img class="img" src="../../../../public/img/titlebg.png">
              <span class="product-span">
                {{item.groupName}}
              </span>
            </div>
            <div style="margin-top: 5px" class="productTable">
              <table width="100%" cellspacing="0" style="background: #fafafa">
                <tr>
                  <th
                      v-for="(item1,index1) in item.productIntroductionTemplateParams"
                      :key="index1"
                      style="padding: 10px;">
                    {{item1.paramName}}
                  </th>
                </tr>
                <tr
                    v-for="(item2,index2) in item.productIntroductionTemplateParams[0].children"
                    :key="index2"
                    class="hover">
                  <td
                      v-for="(item3,index3) in item.productIntroductionTemplateParams"
                      :key="index3"
                      style="padding: 10px;">
                    <div>{{item3.children[index2]}}</div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    name:"ProductPreview",
    components: {},
    data() {
      return {
        currentIndex: 0,   //默认显示图片
        timer: null,    //定时器
        tableData: [],
        productPictureList: [],
        paramValueTable: [],
        enumerateList:[],
        model: {
          id: 0,
          name: "",
          model: "",
          categoryId: 0,
          categoryName: "",
          richDetails: "",
          remark: "",
          productIntroductionTemplateGroupVOS: [],
        },
        ruleValidate: {
        },
      };
    },
    computed: {
      //上一张
      prevIndex() {
        if(this.currentIndex == 0) {
          return this.productPictureList.length - 1;
        }else{
          return this.currentIndex - 1;
        }
      },
      //下一张
      nextIndex() {
        if(this.currentIndex == this.productPictureList.length - 1) {
          return 0;
        }else {
          return this.currentIndex + 1;
        }
      },
    },
    destroyed: function() {
      clearInterval(this.timer);
      this.timer = null;
    },
    created() {
      this.model.id = this.$route.params.id;
      console.log(this.$route.params);
      this.$nextTick(() => {
        this.getData();
      });
    },
    methods: {
      getData() {
        this.$http
          .get("basic", `products/${this.model.id}`)
          .then(resp => {
            this.model = resp;
            this.tableData = resp.productIntroductionTemplateGroupVOS;
            if (this.model.productPictureList) {
              for (const file of this.model.productPictureList) {
                this.productPictureList.push({url: this.getFullUrl(file), path: file});
              }
            }
            console.log(this.model);
            //this.runInv();
          });
      },
      getFullUrl(row) {
        console.log(row);
        let newfileName = row.filePath.substring(row.filePath.lastIndexOf("\\")+1);
        console.log(newfileName);
        // return  window.config.basicServerUrl + "file/download?uuid=" + row.filePath+"&name=" + row.pictureName;
        return  window.config.fileServerUrl + newfileName;
      },
      gotoPage(index) {
        this.currentIndex = index;
      },
      runInv() {
        this.timer = setInterval(() => {
          this.gotoPage(this.nextIndex);
        }, 5000);
      },
    },
  };
</script>


<style lang="scss" scoped>
  @import "../../../style/index";
  @media (min-width: 320px) and (max-width: 640px) {
    .product-span,.product-span2,.product-span3{
      font-size: 15px!important;
    }
    .img{
      width: 8px!important;
      margin-left: 5px;
    }
    .productTable{
      tr{
        th{
          font-size: 15px!important;
        }
        td{
          div{
            font-size: 15px!important;
          }
        }
      }
    }
    .banner{
      height: 320px!important;
      background: #eeeeee;
      padding-bottom: 24px;
      .banner-top{
        font-size: 16px!important;
        i{
          position: absolute;
          transform: translateY(-50%);
          top: 50%;
          right: 30px;
          font-size: 16px!important;
        }
        i:first-child{
          right: 55px!important;
        }
      }
      .item{
        height: 78%!important;
        .banner-img{
          height: 100%!important;
        }
      }
      .page{
        height: 6em!important;
        bottom: 10px!important;
        ul{
          position: absolute;
          left: 0;
          bottom: 0!important;
          z-index: 4;
          width: 100%;
          height: 6em!important;
          li{
            height: 6em!important;
            .banner-img2{
              width: 27px!important;
              top:-26px!important;
            }
            span{
              height: 2em!important;
              line-height: 2em!important;
              font-size: 12px!important;
              position: absolute;
              bottom: 0px;
            }
          }
          /*<!--li.current,li:hover {-->*/
          /*<!--  transform:scale(1.2);-->*/
          /*<!--  -webkit-transform:scale(1.2);  !*兼容-webkit-引擎浏览器*!-->*/
          /*<!--  -moz-transform:scale(1.2);     !*兼容-moz-引擎浏览器*!-->*/
          /*<!--  cursor: pointer;-->*/
          /*<!--  z-index: 9999;-->*/
          /*<!--  span{-->*/
          /*<!--    bottom: .6em!important;-->*/
          /*<!--  }-->*/
          /*<!--  .banner-img2{-->*/
          /*<!--    width: 18px!important;-->*/
          /*<!--    top: -17px!important;-->*/
          /*<!--  }-->*/
          /*<!--}-->*/
        }
      }

    }
  }
  .banner {
    background: #ffffff;
    padding-bottom: 24px;
    height: 676px;
    overflow: hidden;
    position: relative;
    background: #eeeeee;
    padding-bottom: 24px;
    .banner-top{
      display: block;
      background: rgba(57,110,179,0.6);
      height: 2em;
      line-height: 2em;
      font-size: 1.3em;
      color: #fff;
      text-align: center;
      position: absolute;
      top: 0px;
      width: 100%;
      z-index: 9999;
      i{
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
        right: 30px;
        font-size: 1.3em;
      }
      i:first-child{
        right: 75px;
      }
    }
    .item{
      width: 100%;
      position: relative;
      overflow: hidden;
      .banner-img {
        width: 100%;
        height: 520px;
        display: block;
      }
    }
    .page {
      position: absolute;
      right: 0;
      bottom: 15px;
      width: 100%;
      height: 10em;
      border-top: 10px solid #eeeeee;
      ul {
        position: absolute;
        left: 0;
        bottom: 10px;
        z-index: 4;
        width: 100%;
        height: 10em;
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
        flex-direction: row;
        border-top: 10px solid #eeeeee;
        align-items: center;
        li{
          position: relative;
          list-style: none;
          position: relative;
          height: 11em;
          width: 25%;
          background-repeat: no-repeat;
          .banner-img1 {
            width: 100%;
            height: 100%;
          }
          .banner-img2{
            width: 40px;
            position: absolute;
            top: -35px;
            left: 50%;
            transform: translateX(-50%);
          }
          span{
            display: block;
            width: 98%;
            margin: 0 1%;
            background: rgba(57,110,179,0.6);
            height: 2em;
            line-height: 2em;
            font-size: 1.3em;
            color: #fff;
            text-align: center;
            position: absolute;
            bottom: 0px;
          }
        }
        /*<!--li.current,li:hover {-->*/
        /*<!--  transform:scale(1.2);-->*/
        /*<!--  -webkit-transform:scale(1.2);  !*兼容-webkit-引擎浏览器*!-->*/
        /*<!--  -moz-transform:scale(1.2);     !*兼容-moz-引擎浏览器*!-->*/
        /*<!--  cursor: pointer;-->*/
        /*<!--  z-index: 9999;-->*/
        /*<!--  .banner-img2{-->*/
        /*<!--    width: 26px;-->*/
        /*<!--    top: -23px;-->*/
        /*<!--  }-->*/
        /*<!--  span{-->*/
        /*<!--    bottom: .9em;-->*/
        /*<!--  }-->*/
        /*<!--}-->*/
      }
    }
  }
  .current {
    color: #ff6700;
  }
  .editor {
    border: 1px solid $border-color;
  }
  .product-span{
    color: #00449b;
    font-size: 1.8em;
    margin-left: 5px;
  }
  .product-span2{
    display: block;
    font-size: 1.5em;
    width: 25%;
  }
  .product-span3{
    text-align: right;
    font-size: 1.5em;
  }
  .productTable{
    tr{
      th{
        border: 1px solid #eeeeee;
        font-size: 1.5em;
        font-weight: 600;
      }
      th:nth-child(2){
        border-left: none;
        border-right: none;
      }
      td{
        border: 1px solid #eeeeee;
        border-top: none;
        div{
          width: 100%;
          text-align: center;
          font-size: 1.5em;
        }
      }
      td:nth-child(2){
        border-left: none;
        border-right: none;
      }
    }
  }
</style>
